import React from 'react'
import { Box, Flex, BoxProps } from '@fundamentals'
import { SxProps, Typography } from '@mui/material'
import { IconButton, Tooltip } from '@common/material'
import { Edit } from '@mui/icons-material'

type PropertyProps = BoxProps & {
  heading: string
  subHeading?: string
  subHeadingComponent?: React.ReactNode
  onEdit?: () => void
  horizontal?: boolean
  sx?: SxProps
}
export const Property: React.FC<PropertyProps> = ({
  heading,
  subHeading,
  subHeadingComponent,
  onEdit,
  horizontal = false,
  sx = { mb: 1 },
  ...props
}) => {
  return (
    <Box
      sx={{ ...sx }}
      display={horizontal ? 'flex' : 'block'}
      alignItems={horizontal ? 'center' : 'flex-start'}
      {...props}
    >
      {heading && (
        <Typography
          sx={{ fontSize: 12 }}
          color='text.secondary'
          gutterBottom={!horizontal}
          flex={horizontal ? 1 : 0}
        >
          {heading}
        </Typography>
      )}
      <Flex
        flexWrap={'wrap'}
        rowGap={1}
        flexDirection={'row'}
        alignItems={'center'}
        flex={horizontal ? 2 : 0}
        minWidth={0}
      >
        {subHeading && (
          <Tooltip title={subHeading}>
            <Typography noWrap>{subHeading}</Typography>
          </Tooltip>
        )}
        {subHeadingComponent && subHeadingComponent}
        {onEdit && (
          <IconButton size={'small'} onClick={onEdit} sx={{ ml: 1 }}>
            <Edit />
          </IconButton>
        )}
      </Flex>
    </Box>
  )
}
